<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="device.name"/>
        <show-actions
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
        ></show-actions>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="bold-text label-color">
              {{ $t('device.Type') }}
            </div>
            <div>
              {{ getValueDeep('type', 'name') }}
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.Brand') }}
            </div>
            <div>
              {{ getValue("brand") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.Model') }}
            </div>
            <div>
              {{ getValue("model") }}
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.SerialNumber') }}
            </div>
            <div>
              {{ getValue("serialNumber") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.Year') }}
            </div>
            <div>
              {{ getValue("year") }}
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.Power') }}
            </div>
            <div>
              {{ getValue("power") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('device.LastMaintenance') }}
            </div>
            <div>
              {{ getValueDate("lastMaintenance") }}
            </div>
          </div>
        </div>


        <div v-if="photoDevices && photoDevices.length > 0">
          <div>
            <div class="bold-text label-color mt-4 mb-2" style="font-size: 150%;">
              {{ $t("Photos") }}
            </div>
            <div class="row ">
              <div v-for="photoDevice in photoDevices" class="col-12 col-md-6 col-lg-3">
                <a :href=fullFileUrl(photoDevice.fileUrl) class="" target="_blank">
                  <button class="btn-icon download-photo-icon">
                    <download-icon/>
                  </button>
                </a>
                <img
                    style="width: 100%"
                    :src="fullFileUrl(photoDevice.fileUrl)"
                    @click="zoomOnImage(fullFileUrl(photoDevice.fileUrl))"
                    alt="Photo associée à l'appareil"
                >
              </div>
            </div>
          </div>
        </div>

        <!--region pdf des appareils-->
        <b-row>
          <div v-if="fileInterventions && fileInterventions.length > 0" class="mt-4 mb-2 col-6">
            <div class="label-color bold-text mb-2" style="font-size: 150%;">{{ $t('FileInterventions') }}</div>
            <div v-for="fileIntervention in fileInterventions" class="d-flex mb-2 main-color">
              <file-text-icon size="26" class="mr-2"/>
              <a :href=fullFileUrl(fileIntervention.fileUrl) target="_blank">{{ fileIntervention.name }}</a>
              <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document">
                <trash-icon size="20"/>
              </button>
            </div>
          </div>
        </b-row>
        <!--endregion-->
      </b-card>
    </b-container>

    <!-- Modal Zoom on image -->
    <zoom-on-image v-if="ui.zoomOnImageSrc !== null" :src="ui.zoomOnImageSrc" @didCloseZoomOnImage="didCloseZoomOnImage"></zoom-on-image>

    <!-- Modal Delete -->
    <device-delete-modal :selectedDevice="device" @didDeleteDevice="didDeleteDevice()"></device-delete-modal>
    <file-intervention-delete-modal :file="fileIntervention" @didDeleteFileIntervention="didRemoveFileDB()"></file-intervention-delete-modal>

  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
import B122Table from "../../components/b122/B122Table";
import DeviceDeleteModal from "./DeviceDeleteModal";
import ZoomOnImage from "../../components/b122/ZoomOnImage";
import FileInterventionDeleteModal from "../intervention/FileInterventionDeleteModal";
import {dateUtils} from "../../mixins/utils";

export default {

  name: 'DeviceShow',

  mixins: [dateUtils],

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    DeviceDeleteModal,
    ZoomOnImage,
    FileInterventionDeleteModal
  },

  data() {
    return {
      deviceId: this.$route.params.deviceId,
      clientName: this.$route.params.clientName,
      device: {},
      ui: {
        zoomOnImageSrc: null
      },
      photoDevices: {},
      fileInterventions: [],
      fileIntervention: null,
    }
  },

  computed: {
    getValue() {
      return property => (this.device[property] || this.device[property] == false) ? this.device[property] : "N/A"
    },
    getValueDeep() {
      return (prop1, prop2) => ((this.device[prop1] || this.device[prop1] === false) &&
        (this.device[prop1][prop2] || this.device[prop1][prop2] === false)) ? this.device[prop1][prop2] : "N/A"
    },
    getValueDate() {
      return property => (this.device[property] && this.device[property] !== 0) ? this.formatDate(this.device[property]) : "N/A"
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchDevice()
      this.fetchFileDevice()
      this.fetchFileInterventions()
    },

    fetchFileDevice() {
      return api
          .get(`/fileDevice/getFileDevicesByDeviceId?deviceId=${this.deviceId}`)
          .then(response => {
            this.photoDevices = response.data
          })
    },

    fetchFileInterventions(){
      return api
        .get(`/fileIntervention/getFileInterventionsByDeviceId?deviceId=${this.deviceId}`)
        .then(response => {
          this.fileInterventions = response.data
        })
    },

    fetchDevice() {
      api
          .get(`/device/${this.deviceId}`)
          .then(response => {
            this.device = response.data
          })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'DeviceEdit',
        params: {
          deviceId: this.device.id,
          clientName: this.clientName
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('device-delete-modal')
    },

    didDeleteDevice() {
      this.$router.back()
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    fullFileUrl(fileUrl) {
      return process.env.SERVER_URL + fileUrl
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    },

    removeFileDB(file){
      this.fileIntervention = file
      this.$bvModal.show('file-intervention-delete-modal')
    },

    didRemoveFileDB(){
      this.fetchFileInterventions()
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/device/DeviceShow.vue